import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_HTML_CONFIG } from './cms-component-html.config';
import { NCmsComponentHtml } from './cms-component-html.interface';

@Component({
    selector: 'cms-component-html',
    templateUrl: './cms-component-html.component.html',
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentHtmlComponent>(CMS_COMPONENT_HTML_CONFIG)
export class CmsComponentHtmlComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentHtml.IData;
}
